import React from "react";
import tw from "twin.macro";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Footer from "components/footers/FourColumnWithInputForm.js";
import Header from "./../components/headers/HeaderLight";
import { SectionHeading as HeadingBase } from "components/misc/Headings";
import { css } from "styled-components/macro"; //eslint-disable-line
import { Row, Col } from "reactstrap";
import { SectionDescription as DescriptionBase } from "components/misc/Typography";
import { Container } from "components/misc/Layouts";
import DocumentsTable from "components/tables/DocumentsTable.js";
import IllustrationSrc from "images/demo/documentation.png";
import styled from "styled-components";
import { ReactComponent as SvgDotPattern } from "images/dot-pattern.svg"

const Column = tw.div`flex-1`;
const ImageColumn = tw(Column)`mx-auto lg:mr-0 relative mt-16 lg:mt-0 lg:ml-8`;
const Image = tw.img`max-w-full rounded-t sm:rounded`;
const TextColumn = tw(Column)`mx-auto lg:mr-0 max-w-2xl lg:max-w-xl xl:max-w-2xl flex-shrink-0`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24 items-center`;

const Heading = tw(HeadingBase)`text-center lg:text-left text-primary-900 leading-snug`;
const Description = tw(
    DescriptionBase
)`mt-4 text-center lg:text-left lg:text-base text-gray-700 max-w-lg mx-auto lg:mx-0`;
const DecoratorBlob = styled(SvgDotPattern)(props => [
    tw`w-20 h-20 absolute right-0 bottom-0 transform translate-x-1/2 translate-y-1/2 fill-current text-primary-500 -z-10`,
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;

export default () => {
    const tableData = [
        {
            name: "Reglamento General",
            updatedDate: "06/2024",
            file: "/sample.pdf"
        },
        {
            name: "Aviso Privacidad",
            updatedDate: "06/2024",
            file: "/sample.pdf"
        },
        {
            name: "Uso Alberca",
            updatedDate: "06/2024",
            file: "/sample.pdf"
        },
    ]; 

    return (
        <AnimationRevealPage>
            <Header />
            <Container>
                <TwoColumn>
                    <ImageColumn>
                        <Image css={null} src={IllustrationSrc} imageBorder={false} imageShadow={false} imageRounded={true} />
                    </ImageColumn>
                    <TextColumn textOnLeft={true}>
                        <TextContent>
                            {/* <Subheading>{subheading}</Subheading> */}
                            <Heading>{"Documentos del Fraccionamiento"}</Heading>
                            <Description>{"Aquí encontrarás los documentos oficiales de tu fraccionamiento: reglamento interno, avisos de privacidad y normas de uso de las amenidades. Descarga o consulta cualquier documento en línea."}</Description>
                        </TextContent>
                    </TextColumn>
                </TwoColumn>
            </Container>
            <Row id="table" name="table">
                <Col lg="12">
                    <DocumentsTable title="Lista vigente" tableData={tableData} />
                </Col>
            </Row>
            <Footer />
        </AnimationRevealPage>
    );
};
